import {AfterViewChecked, Component, OnInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MenuItem } from 'primeng/api';

import { UserService } from '@app/core';
import { RouteLink, BreadcrumbMain, BreadcrumbServices } from '@app/shared';


@Component({
  selector: 'app-help-center',
  templateUrl: './help-center.component.html',
  styleUrls: ['./help-center.component.css']
})
export class HelpCenterComponent implements OnInit, AfterViewChecked {

  RouteLink: typeof RouteLink = RouteLink;
  breadcrumb: MenuItem[] = [];
  tabName: string;
  fragment: string;
  activeIndex: number = 0;
  helpGettingStarted: boolean;
  helpNavigating: boolean;
  helpEssMssHcm: boolean;
  helpTimeExpense: boolean;
  helpBidsContracts: boolean;
  helpEstimatesProjects: boolean;
  helpProcurementOrders: boolean;
  helpFinancePayroll: boolean;
  helpAnalytics: boolean;
  displayJ: boolean;
  helpExpenseAdd: boolean = false;
  helpExpenseEnter: boolean = false;
  helpExpenseUpload: boolean = false;
  helpExpenseOverview: boolean = false;
  helpTimesheetOverview: boolean = false;
  helpTimesheetView: boolean = false;
  helpTimesheetSubmit: boolean = false;
  helpPurchaseReqOverview: boolean = false;
  helpPurchaseReqCreate: boolean = false;
  helpPurchaseReqSubmit: boolean = false;
  helpWorklistOverview: boolean = false;
  helpWorklistView: boolean = false;
  helpWorklistManage: boolean = false;
  helpAttachmentsOverview: boolean = false;
  helpAttachmentsUpload: boolean = false;
  helpAttachmentsReplace: boolean = false;
  helpToDosOverview: boolean = false;
  helpToDosAddTasks: boolean = false;
  helpToDosUpdateTasks: boolean = false;
  helpEstimatesOverview: boolean = false;
  helpEstimatesAdd: boolean = false;
  helpEstimatesLaborCategories: boolean = false;
  helpConnectOverview: boolean = false;
  helpConnectPeer: boolean = false;
  helpConnectGroup: boolean = false;
  helpConnectSupport: boolean = false;
  helpCalendarOverview: boolean = false;
  helpCalendarSetup: boolean = false;
  helpCalendarHoliday: boolean = false;
  helpChargeCodesOverview: boolean = false;
  helpChargeCodesAccoutGroups: boolean = false;
  helpChargeCodesAddGroups: boolean = false;
  helpChargeCodesAdd: boolean = false;
  helpFinancialSetupOverview: boolean = false;
  helpFinancialSetupChartAccounts: boolean = false;
  helpFinancialSetupCostPools: boolean = false;
  helpWorkAuthOverview: boolean = false;
  helpWorkAuthCreate: boolean = false;
  helpWorkAuthResources: boolean = false;
  helpContractsOverview: boolean = false;
  helpContractsCreate: boolean = false;
  helpContractsOptions: boolean = false;
  helpContractsLaborCategories: boolean = false;
  helpBidsOverview: boolean = false;
  helpBidsCreate: boolean = false;
  helpBidsLaborCategories: boolean = false;
  helpProjectsOverview: boolean = false;
  helpProjectsAdd: boolean = false;
  helpProjectsLaborCategories: boolean = false;
  helpProjectsApprovals: boolean = false;
  helpItemCatalogOverview: boolean = false;
  helpItemCatalogManage: boolean = false;
  helpItemCatalogAddItems: boolean = false;
  helpItemReceiptOverview: boolean = false;
  helpItemReceiptManage: boolean = false;
  helpItemReceiptReturns: boolean = false;
  helpVendorsOverview: boolean = false;
  helpVendorsAdd: boolean = false;
  helpVendorsManage: boolean = false;
  helpVendorsTransactions: boolean = false;
  helpAccountsPayableOverview: boolean = false;
  helpAccountsPayableBills: boolean = false;
  helpAccountsPayableManage: boolean = false;
  helpAccountsPayablePayments: boolean = false;
  helpProjectsGantt: boolean = false;
  helpCustomersOverview: boolean = false;
  helpCustomersSetup: boolean = false;
  helpCustomersContacts: boolean = false;
  helpCustomersPayments: boolean = false;
  helpCustomersSalesTax: boolean = false;
  helpConvertingResources: boolean = false;


  constructor (private router: Router, private route: ActivatedRoute, public user: UserService) {
  }

  ngOnInit() {

    this.tabName = this.route.snapshot.params['tabName'];
    console.log(`tabName = ${this.tabName}`);
    switch (this.tabName) {
      case 'contact-us': {
        this.activeIndex = 0;
        break;
      }
      case 'help-topics': {
        this.activeIndex = 1;
        break;
      }
      default: {
        this.activeIndex = 0;
        break;
      }
    }
    console.log(`activeIndex = ${this.activeIndex}`);
    this.breadcrumb.push(BreadcrumbMain);
    this.breadcrumb.push({ label: 'Help Center', routerLink: '/main/help-center' });

    //Scroll to the particular section
    this.route.fragment.subscribe(fragment => { this.fragment = fragment; });

  }

  ngAfterViewChecked(): void {
    try {
      if (this.fragment) {
        document.querySelector('#' + this.fragment).scrollIntoView();
      }
    } catch (e) {
      console.debug("Couldn't scroll to " + this.fragment + e);
    }
  }

  initiateConnectSupport() {
  }

  buildMenu() {

  }
}
